<template>
  <main>
    <div class="banner-wrapper"  v-if="!ownHomepageActive">
      <ag-state-banner
        :inactive-status="true"
        class="ag-state-banner--standalone"
      />
    </div>
    <section class="content-wrapper own-homepage">
      <ag-header
        title="Kanzleihomepage"
      />
      <div class="content__body">
        <div v-if="!ownHomepageActive">
          <h3 class="content__headline">Ihre neue Onlinepräsenz!</h3>
          <p class="content__text">
            Eine digitale Präsenz ist im aktuellen Wirtschaftsumfeld viel wert.
            Unsere modernen Designvorlagen lassen Ihnen Spielraum, sich authentisch und individuell
            zu präsentieren – übersichtlich und responsiv.
          </p>
          <h4 class="content__headline">
            Überzeugen Sie sich selbst und testen Sie unsere Designs für Desktop- und
            mobile Ansicht:
          </h4>
          <a
            class="button-link"
            href="https://www.advogarant.de/marketing/rechtsanwaelte/kanzlei-homepage/"
            target="_blank"
          >
            Für Rechtsanwälte
          </a>
          <a
            class="button-link"
            href="https://www.advogarant.de/marketing/steuerberater/kanzlei-homepage/"
            target="_blank"
          >
            Für Steuerberater
          </a>
          <a
            class="button-link"
            href="https://www.advogarant.de/marketing/sachverstaendige/branchen-homepage/"
            target="_blank"
          >
            Für Sachverständige
          </a>
        </div>
        <div v-if="ownHomepageActive">
          <p>
            Sie haben uns das Erstellen Ihrer Homepage anvertraut - bleiben Sie mit uns in Kontakt,
            damit wir Sie auch weiterhin tatkräftig beraten können. Sind Ihre <strong>Inhalte und
            Ihre Online-Präsenz aktuell</strong>? Mit Änderungswünschen
            (bspw. neue Texte oder eine neue Anschrift) können Sie sich gerne an uns wenden.
          </p>
          <p class="content__text">
            Vielleicht möchten Sie aber auch durch relevante Artikel oder aktuelle Urteile  mehr
            <strong>Bewegung und Leben auf Ihre Homepage</strong> bringen? Wir stellen Ihnen
            diverse “Bausteine” zur Verfügung, die auf Ihrer schon bestehenden Webseite problemlos
            integriert werden können.
          </p>
        </div>
        <ag-info-box />
      </div>
    </section>
  </main>
</template>

<script>
import AgHeader from '@/components/shared/AgHeader.vue';
import AgStateBanner from '@/components/shared/AgStateBanner.vue';
import AgInfoBox from '@/components/shared/AgInfoBox.vue';

export default {
  name: 'own-homepage',
  components: {
    AgHeader,
    AgStateBanner,
    AgInfoBox,
  },
  metaInfo: {
    title: 'Kanzleihomepage',
  },
  props: {
    serviceData: {
      type: Array,
      default: null,
      required: false,
    },
    activeServices: {
      type: Array,
      default: null,
      required: false,
    },
    inactiveServices: {
      type: Array,
      default: null,
      required: false,
    },
  },
  computed: {
    ownHomepageActive() {
      return this.activeServices.find((service) => service.key === 'own-homepage');
    },
  },
};
</script>

<style lang="scss">
</style>
